// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck // added since ameyo is global var defined by script
/* eslint-disable no-console */

import {
  AMEYO_SESSION_EVENTS,
  AMEYO_TOOLBAR_CLICKSTREAM,
  AMEYO_TOOLBAR_EVENTS
} from './clickStream.constant';
import { addClickstreamEvent } from './clickStreamEventService';
import { naviExtension } from './naviExtension.service';
import { poll } from '../utils/polling';
import { noop } from '@utils/common';
import { ExtensionHandler } from '../utils/extension.utils';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

const AUTO_CALL_STORAGE_KEY = 'isAutoCallEnabled';
const LOGGEDIN_STORAGE_KEY = 'ameyoLoggedInAt';

export function registerAmeyoCallbacks(customIntegration: unknown) {
  console.log('__AMEYO registerAmeyoCallbacks', customIntegration, ameyo.integration);
  ameyo.integration.registerCustomFunction('showCrm', customIntegration);
  ameyo.integration.registerCustomFunction('loginHandler', customIntegration);
  ameyo.integration.registerCustomFunction('logoutHandler', customIntegration);
  ameyo.integration.registerCustomFunction('onLoadHandler', customIntegration);
  ameyo.integration.registerCustomFunction('loginStatusHandler', customIntegration);
  ameyo.integration.registerCustomFunction('forceLoginHandler', customIntegration);
  ameyo.integration.registerCustomFunction('selectExtensionHandler', customIntegration);
  ameyo.integration.registerCustomFunction('modifyExtensionHandler', customIntegration);
  ameyo.integration.registerCustomFunction('selectCampaignHandler', customIntegration);
  ameyo.integration.registerCustomFunction('autoCallOnHandler', customIntegration);
  ameyo.integration.registerCustomFunction('autoCallOffHandler', customIntegration);
  ameyo.integration.registerCustomFunction('readyHandler', customIntegration);
  ameyo.integration.registerCustomFunction('breakHandler', customIntegration);
  ameyo.integration.registerCustomFunction('hangupHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferToPhoneHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferInCallHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferToAQHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferToIVRHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferToUserHandler', customIntegration);
  ameyo.integration.registerCustomFunction('transferToCampaignHandler', customIntegration);
  ameyo.integration.registerCustomFunction('conferWithPhoneHandler', customIntegration);
  ameyo.integration.registerCustomFunction('conferWithTPVHandler', customIntegration);
  ameyo.integration.registerCustomFunction('conferWithUserHandler', customIntegration);
  ameyo.integration.registerCustomFunction('conferWithLocalIVRHandler', customIntegration);
  ameyo.integration.registerCustomFunction('handleDisposeCall', customIntegration);
  ameyo.integration.registerCustomFunction('showCrmDetailed', customIntegration);
  ameyo.integration.registerCustomFunction('disposeAndDialHandler', customIntegration);
  ameyo.integration.registerCustomFunction('intializeUI', customIntegration);
}
const disableAmeyoToolbarFlag = window.config?.DISABLE_AMEYO_TOOLBAR === 'true';

export function doLogin(username: string, password: string, force = false) {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'doLogin()',
    data: { username, password: password?.substring(0, 5) || 'not found', force }
  });
  ameyo.integration.doLogin(username, password, 'auth.type.crm.http');
  // try to do normal login, if not try forceLogin after 4 sec
  setTimeout(() => {
    ameyo.integration.doForceLogin(username, password, 'auth.type.crm.http');
    addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
      type: 'doForceLogin()',
      data: { username, password: password?.substring(0, 5) || 'not found', force }
    });
  }, 4000);
  clearAutoCallOn();
  removeAmeyoLoggedIn();
}
export function doLogout() {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'doLogout()'
  });
  clearAutoCallOn();
  removeAmeyoLoggedIn();
  ameyo.integration.doLogout();
}

export function recordAutoCallOn() {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'recordAutoCallOn()'
  });
  localStorage.setItem(AUTO_CALL_STORAGE_KEY, 1);
}

export function clearAutoCallOn() {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'clearAutoCallOn()'
  });
  localStorage.removeItem(AUTO_CALL_STORAGE_KEY);
}

export function removeAmeyoState() {
  try {
    clearAutoCallOn();
    removeAmeyoLoggedIn();
    if (!disableAmeyoToolbarFlag) {
      ameyo?.integration?.doLogout();
      addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
        type: 'removeAmeyoState()'
      });
    }
  } catch (e) {
    //
  }
}
export function isAutoCallEnabled(): boolean {
  return !!localStorage.getItem(AUTO_CALL_STORAGE_KEY);
}

export function setAmeyoLoggedIn() {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'setAmeyoLoggedIn()'
  });
  localStorage.setItem(LOGGEDIN_STORAGE_KEY, Date.now());
}

function removeAmeyoLoggedIn() {
  addClickstreamEvent(AMEYO_TOOLBAR_CLICKSTREAM[AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS], {
    type: 'removeAmeyoLoggedIn()'
  });
  localStorage.removeItem(LOGGEDIN_STORAGE_KEY);
}

export function isAmeyoLoggedIn(): boolean {
  return !!localStorage.getItem(LOGGEDIN_STORAGE_KEY);
}

const ameyoAvailabilityCheckInterval = 1000 * 30; // 30sec
let availabilityPolling;

export function addAmeyoAvailabilityToggleClickstream(
  toggle: boolean,
  clickStreamData?: Record<string, string>
) {
  const { reminderRefId, campaignId, agentRefrenceId } = clickStreamData || {};

  if (toggle) {
    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_AVAILABLE_TOGGLE_ON_SUCCESSFULLY, {
      reminderRefId,
      campaignId,
      agentRefrenceId,
      previousToggleStatus: !toggle,
      newToggleStatus: toggle,
      ameyoStatus: ExtensionHandler.isAvailable(),
      newAmeyoStatus: !ExtensionHandler.isAvailable()
    });
    if (!availabilityPolling) {
      availabilityPolling = poll(
        syncAmeyoAvailability,
        undefined,
        ameyoAvailabilityCheckInterval,
        noop
      );
    }
  } else {
    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_AVAILABLE_TOGGLE_OFF_SUCCESSFULLY, {
      reminderRefId,
      campaignId,
      agentRefrenceId,
      previousToggleStatus: !toggle,
      newToggleStatus: toggle,
      previousAmeyoStatus: ExtensionHandler.isAvailable(),
      newAmeyoStatus: !ExtensionHandler.isAvailable(),
      ameyoStatus: ExtensionHandler.currentAmeyoStatus()
    });
    availabilityPolling && availabilityPolling();
    availabilityPolling = null;
  }
}

const syncAmeyoAvailability = () => {
  if (naviExtension.isAvailable()) {
    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_USER_AVAILABILITY);
  }
};
